import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Demandu ĉe la Plankolava Ĉifono: kiu en nia antaŭĉambro estas la plej klera kaj saĝa? Ŝi tuj respondos: la Gomboto kaj la Sandalo.
    </p>
    
    <p class="mb-3">
      Ili ĉiam komencas sciencan disputon, kiam vidas unu la aliun.
    </p>
    
    <p class="mb-3">
      - Kia malseka estas tiu ĉi mondo! – komencas la Gomboto. 
      – Oni paŝas, paŝas, kaj nenie loketon sekan trovos.
    </p>
    
    <p class="mb-3">
      - Tute ne! – kontestas la Sandalo. 
      – En la mondo regas sekeco.
    </p>
    
    <p class="mb-3">
      - Sed klare ja, ke inundas!
    </p>
    
    <p class="mb-3">
      - Ĝuste dezertas!
    </p>
    
    <p class="mb-3">
      Iliajn diskutojn kutime finas la Pantoflo:
    </p>
    
    <p class="mb-3">
      - Kolegoj, lasu la senutilajn palavrojn. 
      La mondo povas esti kaj seka, kaj malseka: la malseka, kiam la mastrino lavas la plankon, kaj seka – la tutan restantan tempon.
    </p>
    `
  )
}

const itemName = {
  esp: 'Scienca disputo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;